import { useEffect, useRef, useState } from "react";

/**
 * 要素の高さをビューポートの高さに基づいて動的に調整するカスタムフック。
 * ResizeObserver を使用して、要素のサイズや位置の変更を監視します。
 */
export const useDynamicHeight = <T extends HTMLElement>(): {
	/**
	 * `計算された要素の高さ`
	 */
	height: number;
	/**
	 * 高さを監視する要素にアタッチする `ref` オブジェクト
	 */
	ref: React.RefObject<T>;
} => {
	const ref = useRef<T>(null);
	const [height, setHeight] = useState(0);

	useEffect(() => {
		const { current: element } = ref;

		if (element) {
			const observer = new ResizeObserver(() => {
				const topPosition = element.getBoundingClientRect().top;
				const availableHeight = window.innerHeight - topPosition;
				setHeight(availableHeight);
			});
			observer.observe(element);

			return (): void => {
				observer.disconnect();
			};
		}

		return undefined;
	}, []);

	return { height, ref };
};
